import React from 'react';
import { GovIcon } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { Chip, ChipNav } from '@gov-nx/ui/web';

export const Badges = () => {
	const { badges, myFilesFilters, code } = useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<ChipNav aria-label={tsn('formular.pole.zdroj')}>
			{badges.map((badge, index) => (
				<li
					key={badge.nameCode}
					className="whitespace-nowrap [ before:content-none ]">
					<Chip
						asChild
						role="tab"
						aria-label={`${tsn('formular.pole.zdroj')}: ${tsn(badge.nameCode)}`}
						color="primary"
						size="m"
						iconStart={
							<GovIcon
								type="templates"
								name={badge.icon}
							/>
						}
						type={
							myFilesFilters.filter.selectedBadgeIndex === index
								? 'solid'
								: 'outlined'
						}
						aria-selected={myFilesFilters.filter.selectedBadgeIndex === index}>
						<button
							type="button"
							onClick={() => myFilesFilters.selectBadge(index)}>
							{tsn(badge.nameCode)}
						</button>
					</Chip>
				</li>
			))}
		</ChipNav>
	);
};
